/* eslint-disable camelcase */
import { graphql } from "./wp.api.service";

const query = `
mutation CancelReg($id: ID!, $noEmail: Boolean = false) {
	deleteRegistration(input: {id: $id, forceDelete: true, noEmail: $noEmail}) {
	  registration {
		databaseId
	  }
	}
  }
`;

const cancelRegistrationMutation = (useMutation, options) => useMutation(
	["cancelRegistration"],
	(variables) => graphql({
		query,
		variables
	}),
	options
);

export default cancelRegistrationMutation;
